import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router-dom';
import { useAuth } from './auth/AuthContext';
import { LoginPage, peekPostLoginRedirect } from './auth/LoginPage';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { NewReferralPage } from './pages/NewReferralPage';
import { ReferralDetailPage } from './pages/ReferralDetailPage';
function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) {
        return (_jsxs("div", { className: "loading-screen", children: [_jsx("div", { className: "spinner" }), _jsx("p", { children: "Loading\u2026" })] }));
    }
    if (!user) {
        return _jsx(Navigate, { to: "/login", replace: true, state: { from: location } });
    }
    return _jsx(_Fragment, { children: children });
}
/** Remount on each "New Referral" click so draft form state never carries over. */
function NewReferralRoute() {
    const location = useLocation();
    const fresh = location.state?.fresh ?? 0;
    return _jsx(NewReferralPage, {}, fresh);
}
function EditReferralRoute() {
    const { id } = useParams();
    const editReferralId = Number(id);
    if (!Number.isFinite(editReferralId) || editReferralId <= 0) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(NewReferralPage, { editReferralId: editReferralId }, `edit-${editReferralId}`);
}
function LoginRoute() {
    const { user } = useAuth();
    const location = useLocation();
    if (user) {
        const fromState = location.state?.from?.pathname;
        const fromHosted = peekPostLoginRedirect();
        const from = fromHosted || fromState || '/';
        return _jsx(Navigate, { to: from, replace: true });
    }
    return _jsx(LoginPage, {});
}
export default function App() {
    const { loading } = useAuth();
    if (loading) {
        return (_jsxs("div", { className: "loading-screen", children: [_jsx("div", { className: "spinner" }), _jsx("p", { children: "Loading\u2026" })] }));
    }
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginRoute, {}) }), _jsx(Route, { path: "/*", element: _jsx(ProtectedRoute, { children: _jsx(Layout, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(DashboardPage, {}) }), _jsx(Route, { path: "/new", element: _jsx(NewReferralRoute, {}) }), _jsx(Route, { path: "/referrals/:id/edit", element: _jsx(EditReferralRoute, {}) }), _jsx(Route, { path: "/referrals/:id", element: _jsx(ReferralDetailPage, {}) })] }) }) }) })] }));
}
